import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllContracts: build.query<
      GetAllContractsApiResponse,
      GetAllContractsApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/Backoffice/contracts`,
        params: {
          Status: queryArg.status,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getContractById: build.query<
      GetContractByIdApiResponse,
      GetContractByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/Backoffice/backoffice/contracts/${queryArg.id}`,
      }),
    }),
    getContractByUserIdBackoffice: build.query<
      GetContractByUserIdBackofficeApiResponse,
      GetContractByUserIdBackofficeApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/Backoffice/backoffice/contracts/user/${queryArg.userId}`,
      }),
    }),
    getPaymentHistory: build.query<
      GetPaymentHistoryApiResponse,
      GetPaymentHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/Backoffice/backoffice/contracts/${queryArg.id}/payment-history`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getSavingPlan: build.query<GetSavingPlanApiResponse, GetSavingPlanApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/Backoffice/backoffice/contracts/${queryArg.id}/saving-plan`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getStats: build.query<GetStatsApiResponse, GetStatsApiArg>({
      query: () => ({
        url: `/contractservice/v1/Backoffice/backoffice/contracts/stats`,
      }),
    }),
    backfill: build.mutation<BackfillApiResponse, BackfillApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/Backoffice/bes-customers/backfill`,
        method: 'POST',
        params: {
          skip: queryArg.skip,
          take: queryArg.take,
        },
      }),
    }),
    revisionContract: build.mutation<
      RevisionContractApiResponse,
      RevisionContractApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contractRevisions/Contracts/${queryArg.id}/revision`,
        method: 'POST',
        body: queryArg.contractRevisionCreateRequest,
      }),
    }),
    rejectContractRevision: build.mutation<
      RejectContractRevisionApiResponse,
      RejectContractRevisionApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contractRevisions/ContractRevisions/${queryArg.id}/reject`,
        method: 'PUT',
      }),
    }),
    getContractRevisionByUserId: build.query<
      GetContractRevisionByUserIdApiResponse,
      GetContractRevisionByUserIdApiArg
    >({
      query: () => ({
        url: `/contractservice/v1/contractRevisions/ContractRevisions/user`,
      }),
    }),
    getContractRevision: build.query<
      GetContractRevisionApiResponse,
      GetContractRevisionApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contractRevisions/ContractRevisions/${queryArg.id}`,
      }),
    }),
    createContractRevision: build.mutation<
      CreateContractRevisionApiResponse,
      CreateContractRevisionApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contractRevisions/ContractRevisions`,
        method: 'POST',
        body: queryArg.contractRevisionCreateRequest1,
      }),
    }),
    acceptContractRevision: build.mutation<
      AcceptContractRevisionApiResponse,
      AcceptContractRevisionApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contractRevisions/ContractRevisions/${queryArg.id}/accept`,
        method: 'PUT',
      }),
    }),
    addFeature: build.mutation<AddFeatureApiResponse, AddFeatureApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/${queryArg.contractId}/features/${queryArg.feature}`,
        method: 'PATCH',
      }),
    }),
    removeFeature: build.mutation<
      RemoveFeatureApiResponse,
      RemoveFeatureApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/${queryArg.contractId}/features/${queryArg.feature}`,
        method: 'DELETE',
      }),
    }),
    addInvitedMember: build.mutation<
      AddInvitedMemberApiResponse,
      AddInvitedMemberApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/Contract/${queryArg.inviteCode}/Accept`,
        method: 'PATCH',
      }),
    }),
    confirmMember: build.mutation<
      ConfirmMemberApiResponse,
      ConfirmMemberApiArg
    >({
      query: () => ({
        url: `/contractservice/v1/contracts/Contracts/ConfirmMember`,
        method: 'PATCH',
      }),
    }),
    rejectContract: build.mutation<
      RejectContractApiResponse,
      RejectContractApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/Contracts/${queryArg.contractId}/Reject`,
        method: 'PATCH',
      }),
    }),
    getContractByInviteCode: build.query<
      GetContractByInviteCodeApiResponse,
      GetContractByInviteCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/Contracts/${queryArg.inviteCode}/invitecode`,
      }),
    }),
    getContractByPhonenumber: build.query<
      GetContractByPhonenumberApiResponse,
      GetContractByPhonenumberApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/phonenumber/${queryArg.phoneNumber}`,
      }),
    }),
    getContractByUserId: build.query<
      GetContractByUserIdApiResponse,
      GetContractByUserIdApiArg
    >({
      query: () => ({ url: `/contractservice/v1/contracts/user` }),
    }),
    getContract: build.query<GetContractApiResponse, GetContractApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/${queryArg.id}`,
      }),
    }),
    deleteContract: build.mutation<
      DeleteContractApiResponse,
      DeleteContractApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getContractStatus: build.query<
      GetContractStatusApiResponse,
      GetContractStatusApiArg
    >({
      query: () => ({ url: `/contractservice/v1/contracts/Contracts/status` }),
    }),
    hasActiveContractByUserId: build.query<
      HasActiveContractByUserIdApiResponse,
      HasActiveContractByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/user/${queryArg.userId}/has-active`,
      }),
    }),
    generateContractPdf: build.query<
      GenerateContractPdfApiResponse,
      GenerateContractPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/${queryArg.id}/pdf`,
      }),
    }),
    createContract: build.mutation<
      CreateContractApiResponse,
      CreateContractApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts`,
        method: 'POST',
        body: queryArg.contractCreateRequest,
      }),
    }),
    updateUserKycConfirmation: build.mutation<
      UpdateUserKycConfirmationApiResponse,
      UpdateUserKycConfirmationApiArg
    >({
      query: () => ({
        url: `/contractservice/v1/contracts/kyc-confirmation`,
        method: 'PUT',
      }),
    }),
    updatePersonalInfo: build.mutation<
      UpdatePersonalInfoApiResponse,
      UpdatePersonalInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/Contracts/${queryArg.contractId}/PersonalInfo`,
        method: 'PUT',
        body: queryArg.updatePersonalInfoRequest,
      }),
    }),
    updateContractInfo: build.mutation<
      UpdateContractInfoApiResponse,
      UpdateContractInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/ContractInfos/${queryArg.contractId}/info/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.contractInfoUpdateRequest,
      }),
    }),
    getContractInfo: build.query<
      GetContractInfoApiResponse,
      GetContractInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/ContractInfos/${queryArg.id}`,
      }),
    }),
    deleteContractInfo: build.mutation<
      DeleteContractInfoApiResponse,
      DeleteContractInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/ContractInfos/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    addContractInfo: build.mutation<
      AddContractInfoApiResponse,
      AddContractInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/Contracts/${queryArg.contractId}/info`,
        method: 'PUT',
        body: queryArg.contractInfoCreateRequest,
      }),
    }),
    getContractAddress: build.query<
      GetContractAddressApiResponse,
      GetContractAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/ContractAddresses/${queryArg.id}`,
      }),
    }),
    addContractAddress: build.mutation<
      AddContractAddressApiResponse,
      AddContractAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/contracts/Contracts/${queryArg.contractId}/Address`,
        method: 'PUT',
        body: queryArg.contractAddressCreateRequest,
      }),
    }),
    getAllInterimPayments: build.query<
      GetAllInterimPaymentsApiResponse,
      GetAllInterimPaymentsApiArg
    >({
      query: () => ({
        url: `/contractservice/v1/interim-payments/InterimPayments`,
      }),
    }),
    getInterimPaymentsByUserId: build.query<
      GetInterimPaymentsByUserIdApiResponse,
      GetInterimPaymentsByUserIdApiArg
    >({
      query: () => ({
        url: `/contractservice/v1/interim-payments/InterimPayments/user`,
      }),
    }),
    getInterimPayment: build.query<
      GetInterimPaymentApiResponse,
      GetInterimPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/interim-payments/InterimPayments/${queryArg.interimPaymentId}`,
      }),
    }),
    createInterimPayment: build.mutation<
      CreateInterimPaymentApiResponse,
      CreateInterimPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/interim-payments`,
        method: 'POST',
        body: queryArg.interimPaymentCreateRequest,
      }),
    }),
    approveManuelPayment: build.mutation<
      ApproveManuelPaymentApiResponse,
      ApproveManuelPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/manuelPayments/ManuelPayments/${queryArg.paymentId}/Approve)`,
        method: 'PATCH',
      }),
    }),
    rejectManuelPayment: build.mutation<
      RejectManuelPaymentApiResponse,
      RejectManuelPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/manuelPayments/ManuelPayments/${queryArg.paymentId}/Reject)`,
        method: 'PATCH',
      }),
    }),
    getManuelPaymentById: build.query<
      GetManuelPaymentByIdApiResponse,
      GetManuelPaymentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/manuelPayments/ManuelPayments/${queryArg.id}`,
      }),
    }),
    getManuelPaymentByUserId: build.query<
      GetManuelPaymentByUserIdApiResponse,
      GetManuelPaymentByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/manuelPayments/ManuelPayments/${queryArg.contractId}/user`,
      }),
    }),
    createManuelPaymentInCurrency: build.mutation<
      CreateManuelPaymentInCurrencyApiResponse,
      CreateManuelPaymentInCurrencyApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/manuelPayments/ManuelPayments/in-currency/${queryArg.contractId}`,
        method: 'POST',
        body: queryArg.manuelPaymentCreateInCurrencyRequest,
      }),
    }),
    createManuelPayment: build.mutation<
      CreateManuelPaymentApiResponse,
      CreateManuelPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/manuelPayments/ManuelPayments/${queryArg.contractId}`,
        method: 'POST',
        body: queryArg.manuelPaymentCreateRequest,
      }),
    }),
    updatePayPlan: build.mutation<
      UpdatePayPlanApiResponse,
      UpdatePayPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/payPlans/${queryArg.payPlanId}`,
        method: 'PUT',
        body: queryArg.payPlanUpdateRequest,
      }),
    }),
    getAllPayPlans: build.query<
      GetAllPayPlansApiResponse,
      GetAllPayPlansApiArg
    >({
      query: () => ({ url: `/contractservice/v1/payPlans/PayPlans` }),
    }),
    getPayPlansByContractId: build.query<
      GetPayPlansByContractIdApiResponse,
      GetPayPlansByContractIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/payPlans/PayPlans/contract/${queryArg.contractId}`,
      }),
    }),
    getPayPlansByUserId: build.query<
      GetPayPlansByUserIdApiResponse,
      GetPayPlansByUserIdApiArg
    >({
      query: () => ({ url: `/contractservice/v1/payPlans/PayPlans/user` }),
    }),
    getPayPlan: build.query<GetPayPlanApiResponse, GetPayPlanApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/payPlans/PayPlans/${queryArg.payPlanId}`,
      }),
    }),
    deletePayPlan: build.mutation<
      DeletePayPlanApiResponse,
      DeletePayPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/payPlans/PayPlans/${queryArg.payPlanId}`,
        method: 'DELETE',
      }),
    }),
    createPayPlan: build.mutation<
      CreatePayPlanApiResponse,
      CreatePayPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/payPlans/payplans`,
        method: 'POST',
        body: queryArg.payPlanCreateRequest,
      }),
    }),
    updateAllocations: build.mutation<
      UpdateAllocationsApiResponse,
      UpdateAllocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans/${queryArg.savingsPlanId}/allocations`,
        method: 'PATCH',
        body: queryArg.updateAllocationsCommand,
      }),
    }),
    getTransactions: build.query<
      GetTransactionsApiResponse,
      GetTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans/${queryArg.savingsPlanId}/transactions`,
        params: {
          period: queryArg.period,
        },
      }),
    }),
    resumePlan: build.mutation<ResumePlanApiResponse, ResumePlanApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans/${queryArg.savingsPlanId}/resume`,
        method: 'POST',
      }),
    }),
    pausePlan: build.mutation<PausePlanApiResponse, PausePlanApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans/${queryArg.savingsPlanId}/pause`,
        method: 'POST',
      }),
    }),
    listSavingsPlans: build.query<
      ListSavingsPlansApiResponse,
      ListSavingsPlansApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans`,
        params: {
          ownerUserId: queryArg.ownerUserId,
          status: queryArg.status,
        },
      }),
    }),
    createSavingsPlan: build.mutation<
      CreateSavingsPlanApiResponse,
      CreateSavingsPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans`,
        method: 'POST',
        body: queryArg.savingsPlanCreateCommand,
      }),
    }),
    getSavingsPlan: build.query<
      GetSavingsPlanApiResponse,
      GetSavingsPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans/${queryArg.savingsPlanId}`,
      }),
    }),
    executePlan: build.mutation<ExecutePlanApiResponse, ExecutePlanApiArg>({
      query: (queryArg) => ({
        url: `/contractservice/v1/savingsPlans/internal/SavingsPlans/${queryArg.savingsPlanId}/execute`,
        method: 'POST',
        params: {
          year: queryArg.year,
          month: queryArg.month,
        },
      }),
    }),
    getContributionInfo: build.query<
      GetContributionInfoApiResponse,
      GetContributionInfoApiArg
    >({
      query: () => ({
        url: `/contractservice/v1/savingsPlans/SavingsPlans/contribution-info`,
      }),
    }),
    getTransactionsByContractId: build.query<
      GetTransactionsByContractIdApiResponse,
      GetTransactionsByContractIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/transactions/Transactions/Contract/${queryArg.contractId}`,
        params: {
          PayingType: queryArg.payingType,
          DateRangeFilter: queryArg.dateRangeFilter,
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    getAllTransactions: build.query<
      GetAllTransactionsApiResponse,
      GetAllTransactionsApiArg
    >({
      query: () => ({ url: `/contractservice/v1/transactions/Transactions` }),
    }),
    createTransaction: build.mutation<
      CreateTransactionApiResponse,
      CreateTransactionApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/transactions/Transactions`,
        method: 'POST',
        body: queryArg.transactionCreateRequest,
      }),
    }),
    getTransactionById: build.query<
      GetTransactionByIdApiResponse,
      GetTransactionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/transactions/Transactions/${queryArg.id}`,
      }),
    }),
    deleteTransaction: build.mutation<
      DeleteTransactionApiResponse,
      DeleteTransactionApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/transactions/Transactions/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getTransactionsByUserId: build.query<
      GetTransactionsByUserIdApiResponse,
      GetTransactionsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contractservice/v1/transactions/Transactions/user`,
        params: {
          payingCurrency: queryArg.payingCurrency,
          payingType: queryArg.payingType,
        },
      }),
    }),
    getAllMainTypes: build.query<
      GetAllMainTypesApiResponse,
      GetAllMainTypesApiArg
    >({
      query: () => ({ url: `/contractservice/v1/types` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as contractApi };
export type GetAllContractsApiResponse =
  /** status 200 OK */ ContractReadModelPaginationResponseRead;
export type GetAllContractsApiArg = {
  status?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetContractByIdApiResponse =
  /** status 200 OK */ ContractViewModelRead;
export type GetContractByIdApiArg = {
  id: string;
};
export type GetContractByUserIdBackofficeApiResponse =
  /** status 200 OK */ ContractViewModelRead;
export type GetContractByUserIdBackofficeApiArg = {
  userId: string;
};
export type GetPaymentHistoryApiResponse =
  /** status 200 OK */ TransactionReadModelPaginationResponseRead;
export type GetPaymentHistoryApiArg = {
  id: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetSavingPlanApiResponse =
  /** status 200 OK */ InterimPaymentReadModelPaginationResponseRead;
export type GetSavingPlanApiArg = {
  id: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetStatsApiResponse = /** status 200 OK */ ContractStatsViewModel;
export type GetStatsApiArg = void;
export type BackfillApiResponse =
  /** status 200 OK */ BackfillBesCustomersResult;
export type BackfillApiArg = {
  skip?: number;
  take?: number;
};
export type RevisionContractApiResponse = unknown;
export type RevisionContractApiArg = {
  id: string;
  contractRevisionCreateRequest: ContractRevisionCreateRequest;
};
export type RejectContractRevisionApiResponse = unknown;
export type RejectContractRevisionApiArg = {
  id: string;
};
export type GetContractRevisionByUserIdApiResponse =
  /** status 200 OK */ ContractRevisionViewModel[];
export type GetContractRevisionByUserIdApiArg = void;
export type GetContractRevisionApiResponse =
  /** status 200 OK */ ContractRevisionViewModel;
export type GetContractRevisionApiArg = {
  id: string;
};
export type CreateContractRevisionApiResponse =
  /** status 200 OK */ ContractRevisionIdRead;
export type CreateContractRevisionApiArg = {
  contractRevisionCreateRequest1: ContractRevisionCreateRequest1;
};
export type AcceptContractRevisionApiResponse = unknown;
export type AcceptContractRevisionApiArg = {
  id: string;
};
export type AddFeatureApiResponse = unknown;
export type AddFeatureApiArg = {
  contractId: string;
  /** Possible values: gold, none, silver, bes, hayat */
  feature: ContractFeature;
};
export type RemoveFeatureApiResponse = unknown;
export type RemoveFeatureApiArg = {
  contractId: string;
  /** Possible values: gold, none, silver, bes, hayat */
  feature: ContractFeature;
};
export type AddInvitedMemberApiResponse = unknown;
export type AddInvitedMemberApiArg = {
  inviteCode: string;
};
export type ConfirmMemberApiResponse = unknown;
export type ConfirmMemberApiArg = void;
export type RejectContractApiResponse = unknown;
export type RejectContractApiArg = {
  contractId: string;
};
export type GetContractByInviteCodeApiResponse =
  /** status 200 OK */ ContractViewModelRead;
export type GetContractByInviteCodeApiArg = {
  inviteCode: string;
};
export type GetContractByPhonenumberApiResponse =
  /** status 200 OK */ ContractViewModelRead;
export type GetContractByPhonenumberApiArg = {
  phoneNumber: string;
};
export type GetContractByUserIdApiResponse =
  /** status 200 OK */ ContractViewModelRead;
export type GetContractByUserIdApiArg = void;
export type GetContractApiResponse = /** status 200 OK */ ContractViewModelRead;
export type GetContractApiArg = {
  id: string;
};
export type DeleteContractApiResponse = unknown;
export type DeleteContractApiArg = {
  id: string;
};
export type GetContractStatusApiResponse =
  /** status 200 OK */ ContractStatusAgreementStatusTuple;
export type GetContractStatusApiArg = void;
export type HasActiveContractByUserIdApiResponse = /** status 200 OK */ boolean;
export type HasActiveContractByUserIdApiArg = {
  userId: string;
};
export type GenerateContractPdfApiResponse = /** status 200 OK */ Blob;
export type GenerateContractPdfApiArg = {
  id: string;
};
export type CreateContractApiResponse = /** status 201 Created */ string;
export type CreateContractApiArg = {
  contractCreateRequest: ContractCreateRequest;
};
export type UpdateUserKycConfirmationApiResponse = unknown;
export type UpdateUserKycConfirmationApiArg = void;
export type UpdatePersonalInfoApiResponse = unknown;
export type UpdatePersonalInfoApiArg = {
  contractId: string;
  updatePersonalInfoRequest: UpdatePersonalInfoRequest;
};
export type UpdateContractInfoApiResponse =
  /** status 200 OK */ ContractInfoIdRead;
export type UpdateContractInfoApiArg = {
  contractId: string;
  id: string;
  contractInfoUpdateRequest: ContractInfoUpdateRequest;
};
export type GetContractInfoApiResponse =
  /** status 200 OK */ ContractInfoViewModelRead;
export type GetContractInfoApiArg = {
  id: string;
};
export type DeleteContractInfoApiResponse = unknown;
export type DeleteContractInfoApiArg = {
  id: string;
};
export type AddContractInfoApiResponse =
  /** status 200 OK */ ContractInfoCreateResponseRead;
export type AddContractInfoApiArg = {
  contractId: string;
  contractInfoCreateRequest: ContractInfoCreateRequest;
};
export type GetContractAddressApiResponse =
  /** status 200 OK */ ContractAddressViewModelRead;
export type GetContractAddressApiArg = {
  id: string;
};
export type AddContractAddressApiResponse = /** status 201 Created */ string;
export type AddContractAddressApiArg = {
  contractId: string;
  contractAddressCreateRequest: ContractAddressCreateRequest;
};
export type GetAllInterimPaymentsApiResponse =
  /** status 200 OK */ InterimPaymentViewModel[];
export type GetAllInterimPaymentsApiArg = void;
export type GetInterimPaymentsByUserIdApiResponse =
  /** status 200 OK */ InterimPaymentViewModel[];
export type GetInterimPaymentsByUserIdApiArg = void;
export type GetInterimPaymentApiResponse =
  /** status 200 OK */ InterimPaymentViewModel;
export type GetInterimPaymentApiArg = {
  interimPaymentId: string;
};
export type CreateInterimPaymentApiResponse = /** status 201 Created */ string;
export type CreateInterimPaymentApiArg = {
  interimPaymentCreateRequest: InterimPaymentCreateRequest;
};
export type ApproveManuelPaymentApiResponse = unknown;
export type ApproveManuelPaymentApiArg = {
  paymentId: string;
};
export type RejectManuelPaymentApiResponse = unknown;
export type RejectManuelPaymentApiArg = {
  paymentId: string;
};
export type GetManuelPaymentByIdApiResponse =
  /** status 200 OK */ ManuelPaymentViewModel;
export type GetManuelPaymentByIdApiArg = {
  id: string;
};
export type GetManuelPaymentByUserIdApiResponse =
  /** status 200 OK */ ManuelPaymentViewModel;
export type GetManuelPaymentByUserIdApiArg = {
  contractId: string;
};
export type CreateManuelPaymentInCurrencyApiResponse =
  /** status 201 Created */ string;
export type CreateManuelPaymentInCurrencyApiArg = {
  contractId: string;
  manuelPaymentCreateInCurrencyRequest: ManuelPaymentCreateInCurrencyRequest;
};
export type CreateManuelPaymentApiResponse = /** status 201 Created */ string;
export type CreateManuelPaymentApiArg = {
  contractId: string;
  manuelPaymentCreateRequest: ManuelPaymentCreateRequest;
};
export type UpdatePayPlanApiResponse = /** status 200 OK */ string;
export type UpdatePayPlanApiArg = {
  payPlanId: string;
  payPlanUpdateRequest: PayPlanUpdateRequest;
};
export type GetAllPayPlansApiResponse = /** status 200 OK */ PayPlanViewModel[];
export type GetAllPayPlansApiArg = void;
export type GetPayPlansByContractIdApiResponse =
  /** status 200 OK */ PayPlanViewModel[];
export type GetPayPlansByContractIdApiArg = {
  contractId: string;
};
export type GetPayPlansByUserIdApiResponse =
  /** status 200 OK */ PayPlanViewModel[];
export type GetPayPlansByUserIdApiArg = void;
export type GetPayPlanApiResponse = /** status 200 OK */ PayPlanViewModel;
export type GetPayPlanApiArg = {
  payPlanId: string;
};
export type DeletePayPlanApiResponse = unknown;
export type DeletePayPlanApiArg = {
  payPlanId: string;
};
export type CreatePayPlanApiResponse = /** status 200 OK */ PayPlanIdRead;
export type CreatePayPlanApiArg = {
  payPlanCreateRequest: PayPlanCreateRequest;
};
export type UpdateAllocationsApiResponse = unknown;
export type UpdateAllocationsApiArg = {
  savingsPlanId: string;
  updateAllocationsCommand: UpdateAllocationsCommand;
};
export type GetTransactionsApiResponse =
  /** status 200 OK */ SavingsTransactionViewModel[];
export type GetTransactionsApiArg = {
  savingsPlanId: string;
  period?: string;
};
export type ResumePlanApiResponse = unknown;
export type ResumePlanApiArg = {
  savingsPlanId: string;
};
export type PausePlanApiResponse = unknown;
export type PausePlanApiArg = {
  savingsPlanId: string;
};
export type ListSavingsPlansApiResponse =
  /** status 200 OK */ SavingsPlanViewModel[];
export type ListSavingsPlansApiArg = {
  ownerUserId?: string;
  /** Possible values: unknown, active, paused, cancelled */
  status?: PlanStatus;
};
export type CreateSavingsPlanApiResponse =
  /** status 200 OK */ SavingsPlanViewModel;
export type CreateSavingsPlanApiArg = {
  savingsPlanCreateCommand: SavingsPlanCreateCommand;
};
export type GetSavingsPlanApiResponse =
  /** status 200 OK */ SavingsPlanViewModel;
export type GetSavingsPlanApiArg = {
  savingsPlanId: string;
};
export type ExecutePlanApiResponse = unknown;
export type ExecutePlanApiArg = {
  savingsPlanId: string;
  year: number;
  month: number;
};
export type GetContributionInfoApiResponse =
  /** status 200 OK */ BesContributionInfoViewModel;
export type GetContributionInfoApiArg = void;
export type GetTransactionsByContractIdApiResponse =
  /** status 200 OK */ TransactionViewModel[];
export type GetTransactionsByContractIdApiArg = {
  contractId: string;
  /** Possible values: wallet, manuel, card, bank_transfer, gold_transfer, silver_transfer */
  payingType?: PayingType;
  dateRangeFilter: DateRangeFilter;
  search?: string;
  cursor: string;
  limit: number;
};
export type GetAllTransactionsApiResponse =
  /** status 200 OK */ TransactionViewModel[];
export type GetAllTransactionsApiArg = void;
export type CreateTransactionApiResponse = /** status 200 OK */ string;
export type CreateTransactionApiArg = {
  transactionCreateRequest: TransactionCreateRequest;
};
export type GetTransactionByIdApiResponse =
  /** status 200 OK */ TransactionViewModel;
export type GetTransactionByIdApiArg = {
  id: string;
};
export type DeleteTransactionApiResponse = unknown;
export type DeleteTransactionApiArg = {
  id: string;
};
export type GetTransactionsByUserIdApiResponse =
  /** status 200 OK */ TransactionViewModel[];
export type GetTransactionsByUserIdApiArg = {
  /** Possible values: try, usd, eur, gbp, gold, silver */
  payingCurrency?: PayingCurrency;
  /** Possible values: wallet, manuel, card, bank_transfer, gold_transfer, silver_transfer */
  payingType?: PayingType;
};
export type GetAllMainTypesApiResponse =
  /** status 200 OK */ MainTypeViewModel1[];
export type GetAllMainTypesApiArg = void;
export type MainTypeReadModel = {
  id?: number;
  typeName?: string | null;
  mehirTypes?: MehirTypeReadModel[] | null;
};
export type IDomainEvent = object;
export type MainTypeReadModelRead = {
  createdAt?: string;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  domainEvents?: IDomainEvent[] | null;
  id?: number;
  typeName?: string | null;
  mehirTypes?: MehirTypeReadModel[] | null;
};
export type Currency =
  | 'none'
  | 'try'
  | 'usd'
  | 'eur'
  | 'gbp'
  | 'gold'
  | 'silver';
export type MehirTypeReadModel = {
  id?: string;
  name?: string | null;
  mainTypeId?: number;
  mainType?: MainTypeReadModel;
  ratio?: number | null;
  currency?: Currency;
  createdAt?: string;
  isDeleted?: boolean;
};
export type MehirTypeReadModelRead = {
  id?: string;
  name?: string | null;
  mainTypeId?: number;
  mainType?: MainTypeReadModelRead;
  ratio?: number | null;
  currency?: Currency;
  createdAt?: string;
  isDeleted?: boolean;
};
export type MainStatus = 'waiting' | 'approved' | 'completed' | 'rejected';
export type Gender = 'male' | 'female';
export type ContractInfoReadModel = {
  id?: string;
  partnerName?: string | null;
  partnerSurname?: string | null;
  partnerMobilePhone?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ContractAddressReadModel = {
  id?: string;
  cityId?: number;
  cityName?: string | null;
  countyId?: number;
  countyName?: string | null;
  districtId?: number;
  districtName?: string | null;
  streetId?: number;
  streetName?: string | null;
  aptNo?: string | null;
  flatNo?: string | null;
  postCode?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type PersonalInfoReadModel = {
  id?: string;
  name?: string | null;
  surname?: string | null;
  birthDate?: string;
  phoneNumber?: string | null;
  identityNo?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ContractMemberReadModel = {
  id?: string;
  userId?: string | null;
  gender?: Gender;
  addressId?: string | null;
  infoId?: string | null;
  personalInfoId?: string | null;
  info?: ContractInfoReadModel;
  address?: ContractAddressReadModel;
  personalInfo?: PersonalInfoReadModel;
  isKycConfirm?: boolean;
  isConfirmed?: boolean;
  createdAt?: string;
  isDeleted?: boolean;
};
export type Status = 'approve' | 'reject' | 'waiting_for_approve';
export type ManuelPaymentReadModel = {
  id?: string;
  userId?: string | null;
  partnerId?: string | null;
  status?: Status;
  contractId?: string;
  contract?: ContractReadModel;
  amount?: number;
  currency?: Currency;
  date?: string;
  description?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ManuelPaymentReadModelRead = {
  id?: string;
  userId?: string | null;
  partnerId?: string | null;
  status?: Status;
  contractId?: string;
  contract?: ContractReadModel;
  amount?: number;
  currency?: Currency;
  date?: string;
  description?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type Status1 =
  | 'approved'
  | 'rejected'
  | 'waiting_for_approval'
  | 'revision_requested';
export type ContractRevisionReadModel = {
  id?: string;
  offererMemberId?: string;
  status?: Status1;
  totalAmount?: number;
  remainingAmount?: number;
  currency?: Currency;
  contractId?: string;
  contract?: ContractReadModel;
  mehirTypeId?: string;
  mehirType?: MehirTypeReadModel;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ContractRevisionReadModelRead = {
  id?: string;
  offererMemberId?: string;
  status?: Status1;
  totalAmount?: number;
  remainingAmount?: number;
  currency?: Currency;
  contractId?: string;
  contract?: ContractReadModel;
  mehirTypeId?: string;
  mehirType?: MehirTypeReadModelRead;
  createdAt?: string;
  isDeleted?: boolean;
};
export type InterimPaymentReadModel = {
  id?: string;
  userId?: string | null;
  amount?: number;
  payingAmount?: number;
  contractId?: string;
  contract?: ContractReadModel;
  createdAt?: string;
  isDeleted?: boolean;
};
export type InterimPaymentReadModelRead = {
  id?: string;
  userId?: string | null;
  amount?: number;
  payingAmount?: number;
  contractId?: string;
  contract?: ContractReadModel;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ContractFeature = 'gold' | 'none' | 'silver' | 'bes' | 'hayat';
export type PayingCurrency = 'try' | 'usd' | 'eur' | 'gbp' | 'gold' | 'silver';
export type PayingType =
  | 'wallet'
  | 'manuel'
  | 'card'
  | 'bank_transfer'
  | 'gold_transfer'
  | 'silver_transfer';
export type TransactionReadModel = {
  id?: string;
  amount?: number;
  payinAmount?: number;
  payingCurrency?: PayingCurrency;
  payingType?: PayingType;
  payingRate?: number;
  userId?: string | null;
  contractId?: string;
  contract?: ContractReadModel;
  date?: string;
  createdAt?: string;
  isDeleted?: boolean;
};
export type TransactionReadModelRead = {
  id?: string;
  amount?: number;
  payinAmount?: number;
  payingCurrency?: PayingCurrency;
  payingType?: PayingType;
  payingRate?: number;
  userId?: string | null;
  contractId?: string;
  contract?: ContractReadModel;
  date?: string;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ContractReadModel = {
  id?: string;
  userId?: string | null;
  inviteCode?: string | null;
  invitedMemberId?: string | null;
  invitingMemberId?: string | null;
  mehirTypeId?: string | null;
  mehirType?: MehirTypeReadModel;
  totalAmount?: number | null;
  remainingAmount?: number | null;
  originalAmount?: number | null;
  isKycDone?: boolean;
  shareLink?: string | null;
  approvedDate?: string | null;
  rejectedDate?: string | null;
  mainStatus?: MainStatus;
  invitedMember?: ContractMemberReadModel;
  invitingMember?: ContractMemberReadModel;
  userMember?: ContractMemberReadModel;
  partnerMember?: ContractMemberReadModel;
  manualPayments?: ManuelPaymentReadModel[] | null;
  lastRevision?: ContractRevisionReadModel;
  contractRevisions?: ContractRevisionReadModel[] | null;
  interimPayments?: InterimPaymentReadModel[] | null;
  createdAt?: string;
  isDeleted?: boolean;
  contractFeatures?: ContractFeature[] | null;
  transactions?: TransactionReadModel[] | null;
};
export type ContractReadModelRead = {
  id?: string;
  userId?: string | null;
  inviteCode?: string | null;
  invitedMemberId?: string | null;
  invitingMemberId?: string | null;
  mehirTypeId?: string | null;
  mehirType?: MehirTypeReadModelRead;
  totalAmount?: number | null;
  remainingAmount?: number | null;
  originalAmount?: number | null;
  isKycDone?: boolean;
  shareLink?: string | null;
  approvedDate?: string | null;
  rejectedDate?: string | null;
  mainStatus?: MainStatus;
  invitedMember?: ContractMemberReadModel;
  invitingMember?: ContractMemberReadModel;
  userMember?: ContractMemberReadModel;
  partnerMember?: ContractMemberReadModel;
  manualPayments?: ManuelPaymentReadModelRead[] | null;
  lastRevision?: ContractRevisionReadModelRead;
  contractRevisions?: ContractRevisionReadModelRead[] | null;
  interimPayments?: InterimPaymentReadModelRead[] | null;
  createdAt?: string;
  isDeleted?: boolean;
  contractFeatures?: ContractFeature[] | null;
  transactions?: TransactionReadModelRead[] | null;
};
export type ContractReadModelPaginationResponse = {
  items?: ContractReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type ContractReadModelPaginationResponseRead = {
  items?: ContractReadModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type ContractStatus =
  | 'personal_info'
  | 'contract_info'
  | 'agreement'
  | 'kyc'
  | 'partner_kyc'
  | 'waiting_confirm'
  | 'waiting_partner_confirm'
  | 'completed';
export type AgreementStatus =
  | 'none'
  | 'waiting_register'
  | 'waiting_info'
  | 'waiting'
  | 'waiting_partner'
  | 'rejected';
export type ContractStatusAgreementStatusTuple = {
  item1?: ContractStatus;
  item2?: AgreementStatus;
};
export type ContractInfoViewModel = {};
export type ContractInfoViewModelRead = {
  id?: string;
  partnerName?: string | null;
  partnerSurname?: string | null;
  partnerMobilePhone?: string | null;
};
export type ContractAddressViewModel = {};
export type ContractAddressViewModelRead = {
  id?: string;
  cityId?: number;
  cityName?: string | null;
  countyId?: number;
  countyName?: string | null;
  districtId?: number;
  districtName?: string | null;
  streetId?: number;
  streetName?: string | null;
  aptNo?: string | null;
  flatNo?: string | null;
  postCode?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type PersonalInfoViewModel = {
  id?: string;
  name?: string | null;
  surname?: string | null;
  birthDate?: string;
  identityNo?: string | null;
  phoneNumber?: string | null;
};
export type ContractMemberViewModel = {
  id?: string;
  userId?: string | null;
  gender?: Gender;
  addressId?: string | null;
  infoId?: string | null;
  personalInfoId?: string | null;
  info?: ContractInfoViewModel;
  address?: ContractAddressViewModel;
  personalInfo?: PersonalInfoViewModel;
  isConfirmed?: boolean;
  isKycConfirmed?: boolean;
};
export type ContractMemberViewModelRead = {
  id?: string;
  userId?: string | null;
  gender?: Gender;
  addressId?: string | null;
  infoId?: string | null;
  personalInfoId?: string | null;
  info?: ContractInfoViewModelRead;
  address?: ContractAddressViewModelRead;
  personalInfo?: PersonalInfoViewModel;
  isConfirmed?: boolean;
  isKycConfirmed?: boolean;
};
export type MainTypeViewModel = {
  id?: number;
  typeName?: string | null;
};
export type MehirTypeViewModel = {
  id?: string;
  name?: string | null;
  currency?: Currency;
  mainTypeId?: number;
  mainType?: MainTypeViewModel;
};
export type ContractRevisionViewModel = {
  id?: string;
  contractId?: string;
  offererMemberId?: string;
  status?: Status1;
  totalAmount?: number;
  remainingAmount?: number;
  currency?: Currency;
  mehirTypeId?: string;
  mehirType?: MehirTypeViewModel;
  createdAt?: string;
};
export type ManuelPaymentViewModel = {
  id?: string;
  userId?: string | null;
  status?: Status;
  contractId?: string;
  amount?: number;
  currency?: Currency;
  date?: string;
  description?: string | null;
};
export type TransactionViewModel = {
  id?: string;
  amount?: number;
  payinAmount?: number;
  transactionNumber?: string;
  referenceNumber?: string | null;
  payingCurrency?: PayingCurrency;
  payingType?: PayingType;
  payingRate?: number;
  userId?: string | null;
  date?: string;
  createdAt?: string;
};
export type ContractViewModel = {
  id?: string;
  contractStatus?: ContractStatusAgreementStatusTuple;
  userId?: string | null;
  inviteCode?: string | null;
  invitedMemberId?: string | null;
  invitingMemberId?: string | null;
  userMember?: ContractMemberViewModel;
  partnerMember?: ContractMemberViewModel;
  lastRevision?: ContractRevisionViewModel;
  invitedMember?: ContractMemberViewModel;
  invitingMember?: ContractMemberViewModel;
  manuelPayments?: ManuelPaymentViewModel[] | null;
  contractRevisions?: ContractRevisionViewModel[] | null;
  transactions?: TransactionViewModel[] | null;
  totalAmount?: number | null;
  remainingAmount?: number | null;
  originalAmount?: number | null;
  mehirTypeId?: string | null;
  mehirType?: MehirTypeViewModel;
  isKycDone?: boolean;
  mainStatus?: MainStatus;
  contractFeatures?: ContractFeature[] | null;
  createdAt?: string;
  approvedDate?: string | null;
  rejectedDate?: string | null;
  isDeleted?: boolean;
  shareLink?: string | null;
};
export type ContractViewModelRead = {
  id?: string;
  contractStatus?: ContractStatusAgreementStatusTuple;
  userId?: string | null;
  inviteCode?: string | null;
  invitedMemberId?: string | null;
  invitingMemberId?: string | null;
  userMember?: ContractMemberViewModelRead;
  partnerMember?: ContractMemberViewModelRead;
  lastRevision?: ContractRevisionViewModel;
  invitedMember?: ContractMemberViewModelRead;
  invitingMember?: ContractMemberViewModelRead;
  manuelPayments?: ManuelPaymentViewModel[] | null;
  contractRevisions?: ContractRevisionViewModel[] | null;
  transactions?: TransactionViewModel[] | null;
  totalAmount?: number | null;
  remainingAmount?: number | null;
  originalAmount?: number | null;
  mehirTypeId?: string | null;
  mehirType?: MehirTypeViewModel;
  isKycDone?: boolean;
  mainStatus?: MainStatus;
  contractFeatures?: ContractFeature[] | null;
  createdAt?: string;
  approvedDate?: string | null;
  rejectedDate?: string | null;
  isDeleted?: boolean;
  shareLink?: string | null;
};
export type TransactionReadModelPaginationResponse = {
  items?: TransactionReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type TransactionReadModelPaginationResponseRead = {
  items?: TransactionReadModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type InterimPaymentReadModelPaginationResponse = {
  items?: InterimPaymentReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type InterimPaymentReadModelPaginationResponseRead = {
  items?: InterimPaymentReadModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ContractStatsViewModel = {
  totalContracts?: number;
  waitingContracts?: number;
  approvedContracts?: number;
  completedContracts?: number;
  rejectedContracts?: number;
  totalAmount?: number;
  totalRemainingAmount?: number;
};
export type BackfillBesCustomerFailure = {
  userId?: string | null;
  reason?: string | null;
};
export type BackfillBesCustomersResult = {
  total?: number;
  skip?: number;
  take?: number;
  processed?: number;
  succeeded?: number;
  failed?: number;
  hasMore?: boolean;
  failures?: BackfillBesCustomerFailure[] | null;
};
export type ContractRevisionCreateRequest = {
  contractId?: string;
  totalAmount?: number;
  remainingAmount?: number;
  mehirTypeId?: string;
  currency?: Currency;
};
export type ContractRevisionId = {};
export type ContractRevisionIdRead = {
  value?: string;
};
export type ContractRevisionCreateRequest1 = {
  contractId?: string;
  totalAmount?: number;
  remainingAmount?: number;
  mehirTypeId?: string;
  currency?: Currency;
};
export type ContractCreateRequest = {
  name?: string | null;
  surname?: string | null;
  birthDate?: string;
  identityNo?: string | null;
};
export type UpdatePersonalInfoRequest = {
  name?: string | null;
  surname?: string | null;
  birthDate?: string;
  identityNo?: string | null;
};
export type ContractInfoId = {};
export type ContractInfoIdRead = {
  value?: string;
};
export type ContractInfoUpdateRequest = {
  partnerName?: string | null;
  partnerSurname?: string | null;
  partnerMobilePhone?: string | null;
  partnerEmail?: string | null;
  partnerIdentityNo?: string | null;
  totalMehirAmount?: number;
  remainingMehirCount?: number;
};
export type ContractInfoCreateResponse = {};
export type ContractInfoCreateResponseRead = {
  contractId?: string;
  inviteCode?: string | null;
  shareLink?: string | null;
};
export type ContractInfoCreateRequest = {
  partnerName?: string | null;
  partnerSurname?: string | null;
  partnerMobilePhone?: string | null;
  totalAmount?: number;
  remainingAmount?: number;
  mehirTypeId?: string;
  currency?: Currency;
};
export type ContractAddressCreateRequest = {
  cityId?: number;
  cityName?: string | null;
  countyId?: number;
  countyName?: string | null;
  districtId?: number;
  districtName?: string | null;
  streetId?: number;
  streetName?: string | null;
  aptNo?: string | null;
  flatNo?: string | null;
  postCode?: string | null;
};
export type InterimPaymentViewModel = {
  id?: string;
  userId?: string | null;
  contractId?: string;
  amount?: number;
  payingAmount?: number;
  createdAt?: string;
};
export type InterimPaymentCreateRequest = {
  amount?: number;
  payingAmount?: number;
  contractId?: string;
};
export type ManuelPaymentCreateInCurrencyRequest = {
  amount?: number;
  description?: string | null;
  date?: string;
};
export type ManuelPaymentCreateRequest = {
  amount?: number;
  description?: string | null;
  date?: string;
};
export type PayPlanUpdateRequest = {
  paymentMethodId?: string;
  amount?: number;
  paymentDayOfMonth?: number;
  firstPaymentDate?: string;
  contractId?: string;
};
export type PayPlanViewModel = {
  id?: string;
  userId?: string | null;
  contractId?: string;
  cardToken?: string | null;
  amount?: number;
  paymentDayOfMonth?: number;
  firstPaymentDate?: string;
  createdAt?: string;
};
export type PayPlanId = {};
export type PayPlanIdRead = {
  value?: string;
};
export type PayPlanCreateRequest = {
  paymentMethodId?: string;
  amount?: number;
  paymentDayOfMonth?: number;
  firstPaymentDate?: string;
  contractId?: string;
};
export type Channel = 'unknown' | 'bes' | 'gold' | 'silver';
export type AllocationDto = {
  channel?: Channel;
  percentage?: number;
};
export type UpdateAllocationsCommand = {
  savingsPlanId?: string;
  allocations?: AllocationDto[] | null;
};
export type TransactionStatus = 'unknown' | 'pending' | 'success' | 'failed';
export type SavingsTransactionViewModel = {
  id?: string;
  planId?: string;
  executionId?: string;
  channel?: Channel;
  amount?: number;
  status?: TransactionStatus;
  externalRef?: string | null;
  errorCode?: string | null;
  errorMessage?: string | null;
  executedAt?: string | null;
  createdAt?: string;
};
export type SavingsPlanMode = 'unknown' | 'auto' | 'manual';
export type PlanStatus = 'unknown' | 'active' | 'paused' | 'cancelled';
export type AllocationViewModel = {
  id?: string;
  savingsPlanId?: string;
  channel?: Channel;
  percentage?: number;
};
export type SavingsPlanViewModel = {
  id?: string;
  ownerUserId?: string | null;
  linkedPayPlanId?: string;
  mode?: SavingsPlanMode;
  executionDayOfMonth?: number;
  timezone?: string | null;
  status?: PlanStatus;
  allocations?: AllocationViewModel[] | null;
  createdAt?: string;
  updatedAt?: string | null;
};
export type BesFundDto = {
  fundCode?: string | null;
  percentage?: number;
};
export type SavingsPlanCreateCommand = {
  linkedPayPlanId?: string;
  mode?: SavingsPlanMode;
  executionDayOfMonth?: number;
  timezone?: string | null;
  allocations?: AllocationDto[] | null;
  besFunds?: BesFundDto[] | null;
};
export type BesContributionInfoViewModel = {
  payPlanId?: string;
  monthlyAmount?: number;
  regularPaymentDay?: number;
  firstPaymentDate?: string;
};
export type DateRangeFilter = 0 | 1 | 2 | 3 | 4 | 5;
export type TransactionCreateRequest = {
  amount?: number;
  payinAmount?: number;
  payingCurrency?: PayingCurrency;
  payingType?: PayingType;
  payingRate?: number;
  contractId?: string;
};
export type MehirTypeViewModel1 = {
  id?: string;
  name?: string | null;
  mainTypeId?: number;
  currency?: Currency;
};
export type MainTypeViewModel1 = {
  id?: number;
  typeName?: string | null;
  mehirTypes?: MehirTypeViewModel1[] | null;
};
export const {
  useGetAllContractsQuery,
  useLazyGetAllContractsQuery,
  useGetContractByIdQuery,
  useLazyGetContractByIdQuery,
  useGetContractByUserIdBackofficeQuery,
  useLazyGetContractByUserIdBackofficeQuery,
  useGetPaymentHistoryQuery,
  useLazyGetPaymentHistoryQuery,
  useGetSavingPlanQuery,
  useLazyGetSavingPlanQuery,
  useGetStatsQuery,
  useLazyGetStatsQuery,
  useBackfillMutation,
  useRevisionContractMutation,
  useRejectContractRevisionMutation,
  useGetContractRevisionByUserIdQuery,
  useLazyGetContractRevisionByUserIdQuery,
  useGetContractRevisionQuery,
  useLazyGetContractRevisionQuery,
  useCreateContractRevisionMutation,
  useAcceptContractRevisionMutation,
  useAddFeatureMutation,
  useRemoveFeatureMutation,
  useAddInvitedMemberMutation,
  useConfirmMemberMutation,
  useRejectContractMutation,
  useGetContractByInviteCodeQuery,
  useLazyGetContractByInviteCodeQuery,
  useGetContractByPhonenumberQuery,
  useLazyGetContractByPhonenumberQuery,
  useGetContractByUserIdQuery,
  useLazyGetContractByUserIdQuery,
  useGetContractQuery,
  useLazyGetContractQuery,
  useDeleteContractMutation,
  useGetContractStatusQuery,
  useLazyGetContractStatusQuery,
  useHasActiveContractByUserIdQuery,
  useLazyHasActiveContractByUserIdQuery,
  useGenerateContractPdfQuery,
  useLazyGenerateContractPdfQuery,
  useCreateContractMutation,
  useUpdateUserKycConfirmationMutation,
  useUpdatePersonalInfoMutation,
  useUpdateContractInfoMutation,
  useGetContractInfoQuery,
  useLazyGetContractInfoQuery,
  useDeleteContractInfoMutation,
  useAddContractInfoMutation,
  useGetContractAddressQuery,
  useLazyGetContractAddressQuery,
  useAddContractAddressMutation,
  useGetAllInterimPaymentsQuery,
  useLazyGetAllInterimPaymentsQuery,
  useGetInterimPaymentsByUserIdQuery,
  useLazyGetInterimPaymentsByUserIdQuery,
  useGetInterimPaymentQuery,
  useLazyGetInterimPaymentQuery,
  useCreateInterimPaymentMutation,
  useApproveManuelPaymentMutation,
  useRejectManuelPaymentMutation,
  useGetManuelPaymentByIdQuery,
  useLazyGetManuelPaymentByIdQuery,
  useGetManuelPaymentByUserIdQuery,
  useLazyGetManuelPaymentByUserIdQuery,
  useCreateManuelPaymentInCurrencyMutation,
  useCreateManuelPaymentMutation,
  useUpdatePayPlanMutation,
  useGetAllPayPlansQuery,
  useLazyGetAllPayPlansQuery,
  useGetPayPlansByContractIdQuery,
  useLazyGetPayPlansByContractIdQuery,
  useGetPayPlansByUserIdQuery,
  useLazyGetPayPlansByUserIdQuery,
  useGetPayPlanQuery,
  useLazyGetPayPlanQuery,
  useDeletePayPlanMutation,
  useCreatePayPlanMutation,
  useUpdateAllocationsMutation,
  useGetTransactionsQuery,
  useLazyGetTransactionsQuery,
  useResumePlanMutation,
  usePausePlanMutation,
  useListSavingsPlansQuery,
  useLazyListSavingsPlansQuery,
  useCreateSavingsPlanMutation,
  useGetSavingsPlanQuery,
  useLazyGetSavingsPlanQuery,
  useExecutePlanMutation,
  useGetContributionInfoQuery,
  useLazyGetContributionInfoQuery,
  useGetTransactionsByContractIdQuery,
  useLazyGetTransactionsByContractIdQuery,
  useGetAllTransactionsQuery,
  useLazyGetAllTransactionsQuery,
  useCreateTransactionMutation,
  useGetTransactionByIdQuery,
  useLazyGetTransactionByIdQuery,
  useDeleteTransactionMutation,
  useGetTransactionsByUserIdQuery,
  useLazyGetTransactionsByUserIdQuery,
  useGetAllMainTypesQuery,
  useLazyGetAllMainTypesQuery,
} = injectedRtkApi;
